import React from 'react';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import {VRBO_WEB_GLOBAL_MESSAGING_ALERT} from '../../abacus/experiments';
import SearchBannerContainer from '../SearchBannerContainer/SearchBannerContainer';

export const SearchBannerExperimentWrapper = (props) => {
    const {destinationMessage, globalMessages, hasResults} = props;
    return (
        <Experiment name={VRBO_WEB_GLOBAL_MESSAGING_ALERT}>
            <On>
                <section className="Application__searchBanner">
                    <SearchBannerContainer
                        globalMessages={globalMessages}
                        urgencyMessage={destinationMessage}
                        hasResults={hasResults}
                    />
                </section>
            </On>
            <Off>
                {hasResults && (
                    <section className="Application__searchBanner">
                        <SearchBannerContainer
                            urgencyMessage={destinationMessage}
                            hasResults={hasResults}
                        />
                    </section>
                )}
            </Off>
        </Experiment>
    );
};
